import type { CircularProgressProps } from '@mui/material/CircularProgress'
import { useTheme } from '@mui/material/styles'
import { useTranslation } from 'react-i18next'
import { CircularProgress, Tooltip } from '../../../components/generic.tsx'
import type { AnyProtection } from '../../../data/protections/types.ts'
import { dayjs } from '../../../dayjs.ts'

const FRESH_PROTECTION_TIMEOUT = 20

const isFresh = (dateTime: string) => dayjs().tz('UTC').diff(dayjs(dateTime).tz('UTC'), 'minutes') < FRESH_PROTECTION_TIMEOUT

interface NewAlertSpinnerProps extends CircularProgressProps {
	protections: AnyProtection[]
}

export const NewAlertSpinner = ({ protections, ...props }: NewAlertSpinnerProps) => {
	const { t } = useTranslation()
	const theme = useTheme()
	const hasNewProtection = protections.some((p) => p.type === 'lightning' && isFresh(p.createdTime))
	if (protections.length === 0 || !hasNewProtection) return

	return (
		<Tooltip title={t(($) => $.alerts.newAlertDisclaimer)} placement='top'>
			<CircularProgress size={16} {...props} sx={{ color: theme.palette.text.disabled }} />
		</Tooltip>
	)
}
